/** @format */
import { ModuleToggleOverridesComponent, redirectIfTestModeIsDisabled, SisStateDeclaration } from 'sis-components';

export const moduleToggleOverrideStates: SisStateDeclaration[] = [
    {
        name: 'student.module-toggle-overrides',
        url: '/module-toggle-overrides',
        component: ModuleToggleOverridesComponent,
        redirectTo: redirectIfTestModeIsDisabled('student.logged-in.frontpage'),
    },
];
